import { toplevel } from "./toplevel";
import { deprecationWarning, warnOrError, WidgetConfiguration, } from "./WidgetConfiguration";
/**
 * The singleton instance.
 * Initialized by a call to `initializeWidgetConfiguration(widget)`.
 * @deprecated
 */
var configInstance;
/**
 * Initialize and performs sanity checks for your widget.
 * @param widget Your widget contructor or its tag name.
 */
export function initializeWidgetConfiguration(widget, options) {
    if (options === void 0) { options = {}; }
    var widgetTag = widget.is;
    var privateCtor = widget;
    if (privateCtor.__widgetConfiguration__) {
        privateCtor.__widgetConfiguration__.log("Widget configuration already initialized...try to prevent this");
    }
    var globalConfigAvailable = true;
    if (!toplevel.SGWTWidgetConfiguration) {
        toplevel.SGWTWidgetConfiguration = {};
        globalConfigAvailable = false;
    }
    privateCtor.__widgetConfiguration__ = new WidgetConfiguration(widgetTag, toplevel.SGWTWidgetConfiguration, options);
    // DEPRECATED
    configInstance = privateCtor.__widgetConfiguration__;
    // END:DEPRECATED
    performSanityChecks(privateCtor.__widgetConfiguration__, options);
    if (!globalConfigAvailable) {
        privateCtor.__widgetConfiguration__.log("[@sgwt-widget/core] WARNING: SGWTWidgetConfiration was not available. " +
            "It was set to an empty object. Please fix this.");
    }
}
/**
 * TESTS-ONLY: resetting the Widget configuration to the default.
 * @deprecated
 */
export function resetWidgetConfiguration(widget) {
    configInstance = undefined;
    if (toplevel.SGWTWidgetConfiguration &&
        toplevel.SGWTWidgetConfiguration.bus) {
        delete toplevel.SGWTWidgetConfiguration.bus;
    }
    if (widget) {
        var privateCtor = widget;
        if (privateCtor.__widgetConfiguration__) {
            delete privateCtor.__widgetConfiguration__;
        }
    }
}
function defaultConfiguration() {
    var configuration = new WidgetConfiguration("@sgwt-widget/core", {}, {});
    warnOrError(configuration, "initializeWidgetConfiguration(WidgetClass) has not been called." +
        " Using a default configuration. Please report to the widget owner.");
    performSanityChecks(configuration);
    return configuration;
}
/**
 * @deprecated
 */
export function widgetConfiguration() {
    deprecationWarning(configInstance, "widgetConfiguration() will be removed in a future version. Please use SgWidget#widgetConfiguration (for widget itself) or <WidgetConfigurationProvider> and context.widgetConfiguration (for preact components) instead.");
    return configInstance || defaultConfiguration();
}
export function extractWidgetConfiguration(constructor) {
    return constructor.__widgetConfiguration__ || defaultConfiguration();
}
/**
 * Returns a test configuration suitable for use in your tests/specs.
 *
 * **WARNING**: Use only in your test code !!
 */
export function testWidgetConfiguration(options) {
    if (options === void 0) { options = {}; }
    return new WidgetConfiguration("TEST_WIDGET_CONFIGURATION", toplevel.SGWTWidgetConfiguration || { environment: "test" }, options);
}
function performSanityChecks(config, options) {
    if (options === void 0) { options = {}; }
    if (toplevel.jQuery === undefined && !options.disablejQuerySanityCheck) {
        warnOrError(config, "[SANITYCHECK] jQuery is not available." +
            " Widgets might depend on it so you are on your own if you do not load it.");
    }
    if (typeof toplevel.CustomElementRegistry === "undefined") {
        warnOrError(config, "[SANITYCHECK] It seems CustomElementRegistry is not defined at all." +
            " Are you sure the necessary polyfills are loaded ?");
    }
    if (toplevel.fetch === undefined && !options.disableFetchSanityCheck) {
        warnOrError(config, "[SANITYCHECK] It seems fetch is not available." +
            " Are you sure the necessary polyfills are loaded ?");
    }
}
//# sourceMappingURL=index.js.map